import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}
const stateToLang = {
  VALID: null,
  INVALID: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "exportDialog.emailErrors.invalidEmail"
  })
};
const isSend = preference => {
  return preference === 'SEND';
};
const isEmailNotValid = validationState => {
  return validationState !== 'VALID';
};
const getNotificationText = (email, notification, value) => {
  if (email && notification) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToBothText",
      options: {
        value
      }
    });
  } else if (email) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToEmailText",
      options: {
        value
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToNotificationCenterText"
    });
  }
};
const EmailField = ({
  onChange,
  validationState,
  value,
  preferences
}) => {
  if (isEmailNotValid(validationState)) {
    return /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailLabel"
      }),
      help: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailDescription"
      }),
      error: validationState === 'INVALID',
      validationMessage: stateToLang[validationState],
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(TextInput, {
        defaultValue: value,
        onBlur: createValueExtractor(onChange)
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    typography: "body-200",
    marginBlockEnd: "600",
    children: getNotificationText(isSend(preferences.EMAIL), isSend(preferences.NOTIFICATION_SIDEBAR), value)
  });
};
export default EmailField;